import './index.css';
import useTheme from '../../../utilities/hooks/theme';
import Constants from '../../../constants';
import { Image } from '../../../component';
import React from 'react';
interface Props {
  prizeIndex?: number;
  leagueTitleStyle: any;
}
const GadgetLeague = ({ prizeIndex = 0, leagueTitleStyle = {} }: Props) => {
  const { FantasyTheme: theme } = useTheme();
  const gadgetLeagueObj = Constants.GadgetLeague.prizeList[prizeIndex];
  const gadgetLeagueImage = {
    width: 35,
    height: 35,
    alignSelf: 'center'
  };
  return (
    <div style={leagueTitleStyle} className="gadget_league_container">
      <Image style={gadgetLeagueImage} source={gadgetLeagueObj.image} />
      <p
        style={{
          ...leagueTitleStyle,
          color: theme.leagueTitle
        }}>
        {gadgetLeagueObj.title}
      </p>
    </div>
  );
};
GadgetLeague.defaultProps = {
  prizeIndex: 0,
  leagueTitleStyle: {}
};
export default React.memo(GadgetLeague);
